import { parse } from './query.js';

const useGetQueryParams = ()=>{
    return typeof window !== 'undefined' ? parse(window.location.search.substring(1)) : {};
};

export { useGetQueryParams };
//# sourceMappingURL=get-query-params.js.map
